class AddToBasketController {

    constructor(basket, validateService, messageService, itemService, loadingService) {
        this.basket = basket;
        this.validateService = validateService;
        this.messageService = messageService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.item = this.itemService.getItem();
    }

    buttonDisabled () {
        return this.loadingService.isLoading()
            || !this.item.available
            || this.item.phone_only;
    }

    addToBasket () {
        this.messageService.clear();
        if (!this.validate()) {
            return false;
        }

        this.loadingService.startLoading('addToBasket');

        return this.basket.addToBasket(this.guests, this.item)
            .then(() => {
                this.loadingService.stopLoading('addToBasket');

                this.callback();
            });
    }

    validate () {
        let error = this.validateService.itemError(this.item);

        if (!error) {
            error = this.validateService.guestInputCustomiseError(this.guests, this.item);
        }

        if (error) {
            this.messageService.failure(error);
            this.messageService.push();
            return false;
        }

        return true;
    }
}

AddToBasketController.$inject = ['basket', 'validateService', 'messageService', 'itemService', 'loadingService'];

export default AddToBasketController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/basket.add.controller.js